<script lang="ts" setup>
import { useGiDataUploadCollectionStore } from '@/stores/giDataUploadCollection'
import { storeToRefs } from 'pinia'
import { CSV, ZIP } from '@/constants/giDataUploadCollection'

const giDataUploadCollectionStore = useGiDataUploadCollectionStore()

const { uploadFileType } = storeToRefs(giDataUploadCollectionStore)

const UploadFileTypeItems = [
  { text: '.csv', value: CSV },
  { text: '.zip', value: ZIP }
]
</script>

<template>
  <v-col cols="3" class="d-flex"> <v-label>Upload file type:</v-label></v-col>
  <v-col cols="6" class="center">
    <v-radio-group inline hide-details color="primary" v-model="uploadFileType">
      <v-radio
        v-for="(item, index) in UploadFileTypeItems"
        :key="index"
        class="mr-4"
        :label="item.text"
        :value="item.value"
      ></v-radio>
    </v-radio-group>
  </v-col>
</template>
